// Backend format: +2557XXXXXXXX (13 characters)
// UI format: 7XXXXXXXX (9 digits)

export const formatPhoneNumber = (phone) => {
  // Legacy support or direct usage
  return formatForSubmit(phone);
};

export const formatForSubmit = (phone) => {
  if (!phone) return "";
  let clean = String(phone).replace(/\D/g, "");

  // If user entered 07..., strip 0 -> 7...
  if (clean.startsWith("0")) clean = clean.substring(1);

  // If user entered 255..., keep it, but ensure we return with +
  if (clean.startsWith("255")) return "+" + clean;

  // Otherwise prepend +255
  return "+255" + clean;
};

export const formatForDisplay = (phone) => {
  if (!phone) return "";
  let clean = String(phone).replace(/\D/g, "");

  // If it is stored as 255... (with or without +), strip it for display
  if (clean.startsWith("255")) return clean.substring(3);

  // If it is 07... (legacy data), strip 0
  if (clean.startsWith("0")) return clean.substring(1);

  return clean;
};

export const isValidPhoneNumber = (phone) => {
  if (!phone) return false;
  // Strict check on the SUBMIT format (+255 + 9 digits)
  return /^\+255\d{9}$/.test(phone);
};

export const formatVoterId = (value) => {
  // Ensure 'T' is at the start
  if (!value.startsWith("T")) {
    value = "T" + value.replace(/[^0-9]/g, ""); // Remove all non-digit characters and ensure 'T' is at the start
  } else {
    value = "T" + value.slice(1).replace(/[^0-9]/g, ""); // Keep 'T' at the start and remove all non-digit characters from the rest
  }

  // Format the ID according to the specified pattern
  let formattedId = value.slice(0, 1); // 'T'

  if (value.length > 1) formattedId += `-${value.slice(1, 5)}`;
  if (value.length > 5) formattedId += `-${value.slice(5, 9)}`;
  if (value.length > 9) formattedId += `-${value.slice(9, 12)}`;
  if (value.length > 12) formattedId += `-${value.slice(12, 13)}`;

  return formattedId;
};

export const formatNidaId = (value) => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, "");

  // Format the ID according to the specified pattern
  if (digits.length <= 8) {
    return digits;
  } else if (digits.length <= 13) {
    return `${digits.slice(0, 8)}-${digits.slice(8)}`;
  } else if (digits.length <= 18) {
    return `${digits.slice(0, 8)}-${digits.slice(8, 13)}-${digits.slice(13)}`;
  } else {
    return `${digits.slice(0, 8)}-${digits.slice(8, 13)}-${digits.slice(
      13,
      18
    )}-${digits.slice(18, 20)}`;
  }
};
